interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  const maxButtons = Math.min(total, 10);
  let start = Math.max(1, current - Math.floor(maxButtons / 2));
  if (start + maxButtons - 1 > total) start = Math.max(1, total - maxButtons + 1);
  for (let i = 0; i < maxButtons; i += 1) pages.push(start + i);

  return (
    <nav className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="text-[12px] text-foreground-500 order-2 sm:order-1">
        第 {current} 页 / 共 {total} 页
      </p>
      <div className="flex items-center gap-1.5 order-1 sm:order-2 flex-wrap justify-center">
        <button
          type="button"
          disabled={current === 1}
          onClick={() => onChange(current - 1)}
          className="h-8 px-3 rounded-md border border-background-300 text-[12px] text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:border-accent-400 transition-colors cursor-pointer flex items-center gap-1"
        >
          <i className="ri-arrow-left-s-line" />
          上一页
        </button>
        {pages.map((page) => (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`w-8 h-8 rounded-md text-[12px] transition-colors cursor-pointer ${
              page === current
                ? "bg-primary-900 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-accent-400"
            }`}
          >
            {page}
          </button>
        ))}
        <button
          type="button"
          disabled={current === total}
          onClick={() => onChange(current + 1)}
          className="h-8 px-3 rounded-md border border-background-300 text-[12px] text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:border-accent-400 transition-colors cursor-pointer flex items-center gap-1"
        >
          下一页
          <i className="ri-arrow-right-s-line" />
        </button>
      </div>
    </nav>
  );
}